export default __webpack_public_path__ + "static/media/account.011729a3.svg";